const loggingError = (error, info) => {
  // Do something with the error, e.g. log to an external API
  console.log(error, "error", info, "info");
};

export default loggingError;
